import FeatureBanner from './FeatureBanner';

export * from './types';
export default FeatureBanner;
